import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { useStore } from "../../app/stores/store";
import { BookingData } from "../../types/booking";
import toast from "react-hot-toast";
import { formatDateTime } from "../../lib/utils";

const PartnerTransactions = observer(() => {
 const { bookingStore, userStore } = useStore();
  const [bookings, setBookings] = useState<BookingData[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Function to load bookings
    const loadBookings = async () => {
      setLoading(true);
      try {
        const bookingsById = await bookingStore.getBookingByCustomerId(
          userStore.user!.id!
        );
        const bookingsByEmail = await bookingStore.getBookingByEmail(
          userStore.user!.email
        );

        const merged = [...(bookingsById || []), ...(bookingsByEmail || [])];
        const uniqueBookings = Array.from(
          new Map(merged.map((b) => [b.id, b])).values()
        );

        setBookings(uniqueBookings);
      } catch (error) {
        toast.error("Failed to load bookings.");
      } finally {
        setLoading(false);
      }
    };

    // On mount, load bookings once
    loadBookings();

  }, [userStore.user?.id, userStore.user?.email]);

const statusClassMap: Record<string, string> = {
  Completed: "badge-light-success",
  Cancelled: "badge-light-danger",
  Inprogress: "badge-light-warning",
};
  return (
    <>

    
      <div className="row mt-5">
        {/* Last 5 Bookings (you can keep it as static or refactor later) */}
        <div className="col-lg-8 d-flex">
          <div className="card user-card flex-fill">
            <div className="card-header">
              <div className="row align-items-center">
                <div className="col-sm-5">
                  <h5>Last 5 Bookings</h5>
                </div>
                <div className="col-sm-7 text-sm-end">
                  <div className="booking-select">
                    <a className="view-link" href="/react/template/user/user-bookings">
                      View all Bookings
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <div className="table-responsive dashboard-table dashboard-table-info">
<table className="table mb-0">
  <thead>
    <tr>
    <th>Booking Code</th>
      <th>Name</th>
            <th>Service</th>

            <th>Duration</th>

      <th>Amount</th>
      <th>Date</th>
       <th>Status</th>

    </tr>
  </thead>
  <tbody>
    {bookings.length > 0 ? (
        
      bookings.slice(0, 5).map((tx, idx) => (

        
        <tr key={idx}>
            <td>{tx.bookingCode}</td>
          <td>{tx.customerName}</td>
          <td>{tx.serviceName}</td>
          <td>{tx.duration}</td>
          <td className="text-success">{tx.totalPrice} AED</td>
          <td>{(tx.bookingDate)}</td>
<td>
    
<span className={`badge  ${statusClassMap[tx.bookingStatus ?? ""] || "badge-light-warning"}`}>
  {tx.bookingStatus}
</span>
</td>       </tr>
      ))
    ) : (
      <tr>
        <td colSpan={3} className="text-center text-muted py-3">
          No transactions found
        </td>
      </tr>
    )}
  </tbody>
</table>
              </div>
            </div>
          </div>
        </div>

        {/* Recent Transactions */}
        <div className="col-lg-4 d-flex">
          <div className="card user-card flex-fill">
            <div className="card-header">
              <div className="row align-items-center">
                <div className="col-sm-6">
                  <h5>Recent Transactions</h5>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <div className="table-responsive dashboard-table dashboard-table-info">
                <table className="table mb-0">
                  <thead>
                    <tr>
                      <th>Type</th>
                      <th>Amount</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {bookings.length > 0 ? (
                      bookings.slice(0, 5).map((tx, idx) => (
                        <tr key={idx}>
                          <td>{tx.customerName}</td>
                          <td className="text-success">{tx.totalPrice} AED</td>
          <td>{(tx.bookingDate)}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={3} className="text-center text-muted py-3">
                          No transactions found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export default PartnerTransactions;
